"use client";

import { Icon, ospThemes } from "@ospweb/sdk-ui";

import React from "react";
import { cn } from "utils";
import { useCheckAccessClick } from "@/src/hooks/useCheckAccessClick";

interface RelatedPropsType {
  question: string;
  onSendRelatedValue?: (inputString: string) => void;
  className?: string;
}
function RelatedItem({
  question,
  onSendRelatedValue,
  className,
}: RelatedPropsType) {
  const { handleAccessClick } = useCheckAccessClick({
    originClick: () => {
      onSendRelatedValue?.(question);
    },
  });
  return (
    <div
      data-openreplay-label="chatbox_relateditemquestion_click"
      className={cn(
        "rounded-lg py-2 px-3 bg-background_solid_tertiary hover:bg-background_white_overlay10 flex flex-row flex-1 items-center cursor-pointer w-[fit-content] rounded-[8px]",
        "md:flex-1 flex-shrink-0 flex-grow-0 rounded-[8px]",
        className,
      )}
      id="related-card"
      onClick={handleAccessClick}
      role="button"
      aria-label={`RelatedItem question: ${question}`}
      tabIndex={0}
    >
      <div className="mr-1 body_m text-content_secondary">{question}</div>
      <Icon
        name="arrow-right"
        color={ospThemes.colors.content_secondary}
        aria-hidden="true"
      />
    </div>
  );
}

export default React.memo(RelatedItem);
